import './src/styles/global.scss';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faEnvelope, faPhone, faBars, faMapMarkerAlt, faLanguage } from '@fortawesome/free-solid-svg-icons';
import { fab } from '@fortawesome/free-brands-svg-icons'
import { Tooltip } from 'bootstrap';

console.log(Tooltip.NAME)

library.add(fab, faEnvelope, faPhone, faBars, faMapMarkerAlt, faLanguage);
